<app-header [menuList$]="menuList$" [memberInfo$]="memberInfo$"></app-header>

<app-sub-header [currMenu]="currMenu$" [memberInfo]="memberInfo$"></app-sub-header>

<form [formGroup]="form">

  <div class="inner-wrap">
    <div class="info">*필수입력입니다.</div>

    <table>
    <colgroup>
      <col style="width:160px;">
      <col>
    </colgroup>

    <tbody>
    <tr>
      <th><span class="necessary" >*</span>이름</th>
      <td><input type="text" class="ro" value="{{memberInfo.userName}}" readonly="true" /></td>
    </tr>
    <tr>
      <th><span class="necessary">*</span>아이디</th>
      <td><input type="text" class="ro" value="{{memberInfo.userId}}" readonly="true" /></td>
    </tr>
    <tr>
      <th><span class="necessary">*</span>탈퇴사유</th>
      <td><textarea class="reason" id="reason" formControlName="reason" [ngClass]="{formErrors:formErrors['reason']}"></textarea></td>
    </tr>
    </tbody>
    </table>

    <div class="btn-area">
      <button class="btn1" (click)="setMeberOut()">회원탈퇴하기</button>
    </div>
  </div>

</form>

<app-footer></app-footer>